import { Container } from "@/components/atoms";
import { PageHeader, PrivateNetworkFleetLeadersPanel } from "@/components/organisms";

export const PrivateNetworkFleetLeaders = () => {
  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeader title="Private Network" skipCrumbs={1} />
      <PrivateNetworkFleetLeadersPanel />
    </Container>
  );
};
